import {
  IActivityWithTreatmentCode,
  IAPIActivityWithTreatmentCode,
} from '../interface/IActivityWithTreatmentCode'

export const transformAPIActivityWTC = (
  activity: IAPIActivityWithTreatmentCode,
): IActivityWithTreatmentCode => {
  return {
    id: activity.id,
    uuid: activity.uuid,
    name: activity.name,
    description: activity.description,
    color: activity.color,
    duration: activity.duration,
    waitTime: activity.wait_time,
    order: activity.order,
    devices: activity.devices,
    categoryId: activity.category_id,
    is_deleted: activity.is_deleted,
    treatmentCode: activity.treatmentCode,
    unitPrice: activity.unit_price,
    unitPriceExcl: activity.unit_price,
    vatPercentage: activity.vat_percentage
  }
}
